// @flow
import SearchHistory from './SearchHistory';

export default SearchHistory;



// WEBPACK FOOTER //
// ./src/components/search/SearchHistory/index.js